import { useDomainContext } from "@hooks/useDomainContext";
import { useRouter } from "next/router";
import React, { ReactElement } from "react";
import styles from "./styles.module.scss";

export default function SmsTCPA({
    buttonText,
}: {
    buttonText?: string;
}): ReactElement {
    const { domain } = useDomainContext();
    const router = useRouter();
    const showSmsTCPA = domain.config?.showSmsTCPA && !router.query.ts;
    // const linkColor = domain.config?.smsTCPALinkColor
    //     ? domain.config?.smsTCPALinkColor
    //     : "rgb(63, 127, 234)";

    return showSmsTCPA ? (
        <>
            <div className={styles["checkbox-wrapper"]}>
                <input type="checkbox" id="sms_tcpa" name="sms_tcpa" />
                <label
                    htmlFor="sms_tcpa"
                    className={`flex justify-center ${styles["checkbox-label"]} cursor-pointer mb-1`}
                >
                    <span className={styles["box"]}>
                        <svg viewBox="0,0,50,50">
                            <path d="M5 30 L 20 45 L 45 5"></path>
                        </svg>
                    </span>
                    <span>
                        By submitting this form or clicking the "{buttonText}"
                        button (or similar), you consent to receive SMS messages
                        from {domain.niceName}. These may include case updates,
                        appointment reminders, and One-Time Passwords (OTPs) for
                        identity verification. Text STOP to opt out at any time.
                    </span>
                </label>
            </div>
            <div className={`${styles["checkbox-wrapper"]}  mt-1`}>
                <input type="checkbox" id="sms_tcpa_2" name="sms_tcpa_2" />
                <label
                    htmlFor="sms_tcpa_2"
                    className={`flex justify-center ${styles["checkbox-label"]} cursor-pointer mb-1`}
                >
                    <span className={styles["box"]}>
                        <svg viewBox="0,0,50,50">
                            <path d="M5 30 L 20 45 L 45 5"></path>
                        </svg>
                    </span>
                    <span>
                        By submitting this form or clicking the "{buttonText}"
                        button (or similar), you agree to receive promotional
                        SMS messages from {domain.niceName}, including legal
                        offers, news, and relevant content. Text STOP to
                        unsubscribe at any time.
                    </span>
                </label>
            </div>
        </>
    ) : (
        <></>
    );
}
